import styled from '@emotion/styled'
import { Flex } from 'shared/ui'

export default styled(Flex)`
  align-items: center;
  margin-left: -4px;
`
